"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("./Select"));

var _Async = _interopRequireDefault(require("./Async"));

var _Creatable = _interopRequireDefault(require("./Creatable"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AsyncCreatable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AsyncCreatable, _React$Component);

  var _super = _createSuper(AsyncCreatable);

  function AsyncCreatable() {
    (0, _classCallCheck2.default)(this, AsyncCreatable);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AsyncCreatable, [{
    key: "render",
    value: function render() {
      var _this = this;

      // taken from the react-select AsyncCreatable ... but basically just wrapping the Async and Creatable components
      return /*#__PURE__*/_react.default.createElement(_Async.default, this.props, function (_ref) {
        var ref = _ref.ref,
            asyncProps = (0, _objectWithoutProperties2.default)(_ref, ["ref"]);
        var asyncRef = ref;
        return /*#__PURE__*/_react.default.createElement(_Creatable.default, asyncProps, function (_ref2) {
          var ref = _ref2.ref,
              creatableProps = (0, _objectWithoutProperties2.default)(_ref2, ["ref"]);
          var creatableRef = ref;
          return _this.props.children(_objectSpread(_objectSpread({}, creatableProps), {}, {
            ref: function ref(select) {
              creatableRef(select);
              asyncRef(select);
              _this.select = select;
            }
          }));
        });
      });
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return _objectSpread(_objectSpread(_objectSpread({}, _Async.default.propTypes), _Creatable.default.propTypes), _Select.default.propTypes);
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        children: function children(props) {
          return /*#__PURE__*/_react.default.createElement(_Select.default, props);
        }
      };
    }
  }]);
  return AsyncCreatable;
}(_react.default.Component);

exports.default = AsyncCreatable;